import { Validators } from '@angular/forms';
import { FieldConfig } from '@sharedComponents/table-dynamic/interfaces';

export function getEquipmentFieldConfig(brands: any[], vendors: any[], locations: any[], users: any[]): FieldConfig[] {
  return [
    { key: 'equipment_code', safeKey: 'equipment_code', label: 'Código de Equipo', type: 'text', visible: true, placeholder: 'Autogenerado si se deja vacío' },
    { key: 'name', safeKey: 'name', label: 'Nombre del Equipo', type: 'text', visible: true },
    { key: 'description', safeKey: 'description', label: 'Descripción', type: 'text', visible: true },
    { key: 'brandId', safeKey: 'brandId', label: 'Marca', type: 'select', options: brands, optionLabel: 'name', optionValue: 'id', visible: true },
    { key: 'model', safeKey: 'model', label: 'Modelo', type: 'text', validators: [Validators.required], visible: true },
    { key: 'serial_number', safeKey: 'serial_number', label: 'Número de Serie', type: 'text', visible: true },
    { key: 'vendorId', safeKey: 'vendorId', label: 'Proveedor', type: 'select', options: vendors, optionLabel: 'name', optionValue: 'id', visible: true },
    { key: 'locationId', safeKey: 'locationId', label: 'Ubicación', type: 'select', options: locations, optionLabel: 'name', optionValue: 'id', visible: true },
    { key: 'purchase_date', safeKey: 'purchase_date', label: 'Fecha de Compra', type: 'date', visible: true },
    { key: 'acceptance_date', safeKey: 'acceptance_date', label: 'Fecha de Ingreso al Lab.', type: 'date', visible: true },
    { key: 'condition_on_arrival', safeKey: 'condition_on_arrival', label: 'Condición al Ingresar', type: 'text', visible: true },
    { key: 'warranty_expiration', safeKey: 'warranty_expiration', label: 'Expiración Garantía', type: 'date', visible: true },
    { key: 'responsible_user_id', safeKey: 'responsible_user_id', label: 'Usuario Responsable', type: 'select', options: users, optionLabel: 'fullName', optionValue: 'user', visible: true },
    { key: 'calibration_period_days', safeKey: 'calibration_period_days', label: 'Período Calibración (Días)', type: 'number', visible: true },
    { key: 'calibration_start_date', safeKey: 'calibration_start_date', label: 'Fecha base para ciclo Calibración', type: 'date', visible: true, visibleOnField: 'calibration_period_days', alertMessage: 'Por defecto será la fecha de ingreso o la de hoy' },
    { key: 'auto_schedule_calibration', safeKey: 'auto_schedule_calibration', label: 'Programar primer evento automáticamente', type: 'switch', visible: true, visibleOnField: 'calibration_period_days' },
    { key: 'maintenance_period_days', safeKey: 'maintenance_period_days', label: 'Período Mantenimiento (Días)', type: 'number', visible: true },
    { key: 'maintenance_start_date', safeKey: 'maintenance_start_date', label: 'Fecha base para ciclo Mantenimiento', type: 'date', visible: true, visibleOnField: 'maintenance_period_days', alertMessage: 'Por defecto será la fecha de ingreso o la de hoy' },
    { key: 'auto_schedule_maintenance', safeKey: 'auto_schedule_maintenance', label: 'Programar primer evento automáticamente', type: 'switch', visible: true, visibleOnField: 'maintenance_period_days' },
  ];
}

export function buildEquipmentFormPayload(item: any): any {
  if (!item) {
    return { 
      status: 'ACTIVE',
      auto_schedule_calibration: true,
      auto_schedule_maintenance: true
    };
  }

  return {
    id: item.id,
    equipment_code: item.equipment_code,
    name: item.name,
    description: item.description,
    condition_on_arrival: item.condition_on_arrival,
    responsible_user_id: item.responsible_user_id,
    model: item.model,
    serial_number: item.serial_number,
    brandId: item.brand?.id ?? item.brandId,
    locationId: item.location?.id ?? item.locationId,
    vendorId: item.vendor?.id ?? item.vendorId,
    purchase_date: item.purchase_date ? new Date(item.purchase_date) : null,
    acceptance_date: item.acceptance_date ? new Date(item.acceptance_date) : null,
    warranty_expiration: item.warranty_expiration ? new Date(item.warranty_expiration) : null,
    calibration_period_days: item.calibration_period_days,
    calibration_start_date: item.calibration_start_date ? new Date(item.calibration_start_date) : null,
    auto_schedule_calibration: item.auto_schedule_calibration ?? true,
    maintenance_period_days: item.maintenance_period_days,
    maintenance_start_date: item.maintenance_start_date ? new Date(item.maintenance_start_date) : null,
    auto_schedule_maintenance: item.auto_schedule_maintenance ?? true
  };
}
